import React from 'react';
import { Link } from 'react-router-dom';
import QuoteForm from '../../components/QuoteForm';
import Seo from '../../components/Seo';
import { PHONE_DISPLAY, PHONE_TEL } from '../../constants/brand';
import { ROUTES } from '../../enum/routes';

export default function HomePage() {
  return (
    <>
      <Seo
        title="Epic Home Pros - Kitchens, Baths, ADUs & Outdoor Living in Texas"
        description="Free remodel estimates across Texas. Epic Home Pros helps homeowners in Austin, Dallas, Houston, and San Antonio start kitchens, bathrooms, ADUs, and outdoor living."
        path={ROUTES.HOME}
      />
      <section className="relative isolate flex min-h-[78vh] w-full items-center overflow-hidden md:min-h-[88vh]">
            <img
              alt="Finished marble kitchen with oak cabinets and a large island"
              className="absolute inset-0 h-full w-full object-cover"
              src="https://images.unsplash.com/photo-1682888818650-0a7cbb35287d?auto=format&fit=crop&w=1920&q=80"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70" aria-hidden="true"></div>
            <div className="container-page relative z-10 py-20 text-white">
              <div className="max-w-3xl">
                <div className="label-eyebrow !text-white/90">Free Remodel Quotes Across Texas</div>
                <h1 className="h-display mt-4 text-white drop-shadow">Custom Kitchens, Baths, ADUs &amp; Outdoor Living in Texas</h1>
                <p className="mt-5 max-w-2xl text-base text-white/90 sm:text-lg">Free estimates for Austin, Dallas, Houston, and San Antonio homeowners. Request a quote, get an on-site visit, and move forward when you're ready.</p>
                <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                  <Link className="btn-primary" to={ROUTES.QUOTE}>Get a Free Quote</Link>
                  <a href={`tel:${PHONE_TEL}`} className="btn-secondary border-white bg-white/10 text-white hover:bg-white hover:text-forest">Call {PHONE_DISPLAY}</a>
                </div>
              </div>
            </div>
          </section>

          <div className="bg-forest py-4">
            <div className="marquee">
              <div className="marquee__track">
                <div className="flex shrink-0 items-center">
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Free on-site estimates</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Free estimates</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>No obligation</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Austin · Dallas · Houston · San Antonio</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Reply within 1 business day</span>
                </div>
                <div className="flex shrink-0 items-center" aria-hidden="true">
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Free on-site estimates</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Free estimates</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>No obligation</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Austin · Dallas · Houston · San Antonio</span>
                  <span className="flex items-center whitespace-nowrap px-6 text-xs font-medium uppercase tracking-wider text-white sm:text-sm"><span className="mr-6 text-white/40" aria-hidden="true">·</span>Reply within 1 business day</span>
                </div>
              </div>
            </div>
          </div>

          <section id="about" className="scroll-mt-24 py-20 sm:py-28">
            <div className="container-page grid grid-cols-1 gap-12 lg:grid-cols-12">
              <div className="lg:col-span-5 reveal" data-reveal-delay="0">
                <div className="label-eyebrow">Why Epic Home Pros</div>
                <h2 className="h-section mt-3 text-ink">A better way to start your next remodel.</h2>
                <p className="mt-5 text-sm text-ink/60">Serving homeowners across Austin, Dallas, Houston, and San Antonio.</p>
              </div>
              <div className="space-y-5 text-base leading-relaxed text-ink/80 lg:col-span-7" data-reveal-group>
                <p className="reveal">Planning a remodel shouldn't mean calling contractor after contractor and hoping you found the right one.</p>
                <p className="reveal">Epic Home Pros makes the first step simple. Tell us what you're looking to build, where you're located, and what you're envisioning. We'll follow up, schedule a visit when needed, and put together a quote.</p>
                <p className="reveal">From kitchens and bathrooms to ADUs and outdoor living, we're here to help you get the project moving.</p>
                <p className="reveal font-medium text-ink">Free estimates. No pressure.</p>
              </div>
            </div>
          </section>

          <section className="bg-cream py-20 sm:py-28">
            <div className="container-page">
              <div className="reveal mx-auto max-w-2xl text-center">
                <div className="label-eyebrow">What We Help With</div>
                <h2 className="h-section mt-3">Four ways to make more of your home.</h2>
              </div>
              <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-4" data-reveal-group>
                <div className="reveal h-full">
                  <Link className="group card-hover flex h-full flex-col overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm" to="/services/kitchen-remodeling">
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img alt="Kitchen remodeling" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://images.unsplash.com/photo-1682888818650-0a7cbb35287d?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <h3 className="h-card text-ink">Kitchen Remodeling</h3>
                      <p className="mt-2 flex-1 text-sm text-ink/70">From a fresh update to a complete kitchen transformation - cabinetry, counters, and finish work planned around your home.</p>
                      <span className="mt-5 inline-flex items-center text-sm font-semibold text-forest group-hover:text-forest-hover">View Kitchen Remodeling<svg className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span>
                    </div>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="group card-hover flex h-full flex-col overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm" to="/services/bathroom-remodeling">
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img alt="Bathroom remodeling" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <h3 className="h-card text-ink">Bathroom Remodeling</h3>
                      <p className="mt-2 flex-1 text-sm text-ink/70">Walk-in showers, new vanities, soaking tubs, and full bathroom renovations - get a free estimate.</p>
                      <span className="mt-5 inline-flex items-center text-sm font-semibold text-forest group-hover:text-forest-hover">View Bathroom Remodeling<svg className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span>
                    </div>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="group card-hover flex h-full flex-col overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm" to="/services/adu-construction">
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img alt="ADU construction" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <h3 className="h-card text-ink">ADU Construction</h3>
                      <p className="mt-2 flex-1 text-sm text-ink/70">Create more space for family, guests, or future plans with a detached, attached, or garage-conversion ADU.</p>
                      <span className="mt-5 inline-flex items-center text-sm font-semibold text-forest group-hover:text-forest-hover">View ADU Construction<svg className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span>
                    </div>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="group card-hover flex h-full flex-col overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm" to="/services/outdoor-living">
                    <div className="relative aspect-[4/3] overflow-hidden">
                      <img alt="Outdoor living" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    </div>
                    <div className="flex flex-1 flex-col p-6">
                      <h3 className="h-card text-ink">Outdoor Living</h3>
                      <p className="mt-2 flex-1 text-sm text-ink/70">Decks, patios, pergolas, outdoor kitchens, and spaces designed for enjoying the Texas outdoors.</p>
                      <span className="mt-5 inline-flex items-center text-sm font-semibold text-forest group-hover:text-forest-hover">View Outdoor Living<svg className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section id="projects" className="scroll-mt-24 py-20 sm:py-28">
            <div className="container-page">
              <div className="reveal mb-12 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
                <div>
                  <div className="label-eyebrow">Project Inspiration</div>
                  <h2 className="h-section mt-3">See what's possible.</h2>
                </div>
                <p className="max-w-md text-ink/70">Explore kitchens, bathrooms, ADUs, and outdoor spaces that show the kinds of projects homeowners across Texas are planning.</p>
              </div>
              <div className="gallery-grid" data-reveal-group data-reveal-step="100">
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Modern kitchen" src="https://images.unsplash.com/photo-1556912173-46c336c7fd55?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Kitchen</div>
                    <div className="gallery-card__title">Modern Kitchen</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Walk-in shower" src="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Bathroom</div>
                    <div className="gallery-card__title">Walk-In Shower</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Backyard living space" src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">ADU</div>
                    <div className="gallery-card__title">Backyard Living Space</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Covered patio" src="https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Outdoor</div>
                    <div className="gallery-card__title">Covered Patio</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Custom cabinetry kitchen" src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Kitchen</div>
                    <div className="gallery-card__title">Custom Cabinetry</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Modern primary bath" src="https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Bathroom</div>
                    <div className="gallery-card__title">Modern Primary Bath</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Guest suite ADU" src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">ADU</div>
                    <div className="gallery-card__title">Guest Suite</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Outdoor entertaining space" src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Outdoor</div>
                    <div className="gallery-card__title">Entertaining Space</div>
                  </figcaption>
                </figure>
                <figure className="gallery-card group reveal">
                  <div className="gallery-card__media">
                    <img alt="Full kitchen remodel" src="https://images.unsplash.com/photo-1682888818650-0a7cbb35287d?w=1600&amp;q=80&amp;auto=format&amp;fit=crop" />
                    <div className="gallery-card__shade" aria-hidden="true"></div>
                  </div>
                  <figcaption className="gallery-card__caption">
                    <div className="gallery-card__label">Kitchen</div>
                    <div className="gallery-card__title">Full Remodel</div>
                  </figcaption>
                </figure>
              </div>
              <p className="reveal mt-8 text-center text-sm text-ink/70">Looking for something similar? <Link className="font-semibold text-forest hover:text-forest-hover" to="/quote">Tell us what you're planning.</Link></p>
            </div>
          </section>

          <section className="bg-cream py-20 sm:py-24">
            <div className="container-page">
              <div className="reveal mx-auto max-w-2xl text-center">
                <div className="label-eyebrow">Our Commitment</div>
                <h2 className="h-section mt-3">Three things you can count on, every project.</h2>
              </div>
              <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-reveal-group>
                <div className="reveal h-full">
                  <div className="h-full rounded-lg border border-black/5 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-tint text-forest">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </span>
                    <h3 className="h-card mt-5 text-ink">A Straightforward Start</h3>
                    <p className="mt-3 text-ink/75">Tell us what you're planning and we'll help you take the next step on the project.</p>
                  </div>
                </div>
                <div className="reveal h-full">
                  <div className="h-full rounded-lg border border-black/5 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-tint text-forest">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                    </span>
                    <h3 className="h-card mt-5 text-ink">Local Expertise</h3>
                    <p className="mt-3 text-ink/75">Your project is reviewed with the homes, neighborhoods, and requirements in your area in mind.</p>
                  </div>
                </div>
                <div className="reveal h-full">
                  <div className="h-full rounded-lg border border-black/5 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-tint text-forest">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </span>
                    <h3 className="h-card mt-5 text-ink">No Pressure</h3>
                    <p className="mt-3 text-ink/75">Your estimate is free and there's no obligation to move forward. You decide what happens next.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-forest py-14 text-white sm:py-20">
            <div className="container-page grid grid-cols-2 gap-8 text-center md:grid-cols-4" data-reveal-group data-reveal-step="120">
              <div className="reveal">
                <div className="font-serif text-5xl leading-none tracking-tight md:text-6xl">4</div>
                <div className="mt-3 text-sm uppercase tracking-wider text-white/75">Texas Metro Areas</div>
              </div>
              <div className="reveal">
                <div className="font-serif text-5xl leading-none tracking-tight md:text-6xl">Free</div>
                <div className="mt-3 text-sm uppercase tracking-wider text-white/75">Estimates</div>
              </div>
              <div className="reveal">
                <div className="font-serif text-5xl leading-none tracking-tight md:text-6xl">1</div>
                <div className="mt-3 text-sm uppercase tracking-wider text-white/75">Business Day Reply</div>
              </div>
              <div className="reveal">
                <div className="font-serif text-5xl leading-none tracking-tight md:text-6xl">100%</div>
                <div className="mt-3 text-sm uppercase tracking-wider text-white/75">Licensed Partners</div>
              </div>
            </div>
          </section>

          <section className="border-y border-black/5 bg-white py-14 sm:py-16">
            <div className="container-page">
              <div className="mx-auto max-w-2xl text-center reveal">
                <div className="label-eyebrow">How It Works</div>
                <h2 className="mt-3 font-serif text-2xl text-ink sm:text-3xl">From idea to estimate in three simple steps.</h2>
              </div>
              <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-5" data-reveal-group>
                <div className="reveal rounded-md border border-black/5 bg-white px-5 py-6 shadow-sm">
                  <div className="text-xs font-semibold uppercase tracking-wider text-forest">01 - Tell Us What You're Planning</div>
                  <p className="mt-2 text-sm text-ink/75">Share a few details about your project, your location, and what you'd like to change.</p>
                </div>
                <div className="reveal rounded-md border border-black/5 bg-white px-5 py-6 shadow-sm">
                  <div className="text-xs font-semibold uppercase tracking-wider text-forest">02 - On-Site Visit</div>
                  <p className="mt-2 text-sm text-ink/75">We'll follow up to learn more about your project and schedule next steps.</p>
                </div>
                <div className="reveal rounded-md border border-black/5 bg-white px-5 py-6 shadow-sm">
                  <div className="text-xs font-semibold uppercase tracking-wider text-forest">03 - Get Your Estimate</div>
                  <p className="mt-2 text-sm text-ink/75">We'll visit your home, look at the space, and prepare your estimate. You decide whether you want to move forward.</p>
                </div>
              </div>
              <div className="mt-8 text-center reveal">
                <Link className="inline-flex items-center text-sm font-semibold text-forest hover:text-forest-hover" to="/quote">Get Your Free Quote<svg className="ml-1.5 h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></Link>
              </div>
            </div>
          </section>

          <section className="bg-cream py-20 sm:py-28">
            <div className="container-page">
              <div className="reveal mx-auto max-w-2xl text-center">
                <div className="label-eyebrow">Where We Work</div>
                <h2 className="h-section mt-3">Right here in Texas.</h2>
                <p className="mt-4 text-ink/75">Epic Home Pros serves homeowners across:</p>
              </div>
              <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2" data-reveal-group>
                <div className="reveal h-full">
                  <Link className="card-hover flex h-full flex-col rounded-xl border border-black/10 bg-white p-6 shadow-sm hover:border-forest/40" to="/locations/austin">
                    <h3 className="font-serif text-xl text-ink">Austin</h3>
                    <p className="mt-2 text-sm text-ink/70">Kitchen · Bath · ADU · Outdoor Living</p>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="card-hover flex h-full flex-col rounded-xl border border-black/10 bg-white p-6 shadow-sm hover:border-forest/40" to="/locations/dallas">
                    <h3 className="font-serif text-xl text-ink">Dallas-Fort Worth</h3>
                    <p className="mt-2 text-sm text-ink/70">Kitchen · Bath · ADU · Outdoor Living</p>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="card-hover flex h-full flex-col rounded-xl border border-black/10 bg-white p-6 shadow-sm hover:border-forest/40" to="/locations/houston">
                    <h3 className="font-serif text-xl text-ink">Houston</h3>
                    <p className="mt-2 text-sm text-ink/70">Kitchen · Bath · ADU · Outdoor Living</p>
                  </Link>
                </div>
                <div className="reveal h-full">
                  <Link className="card-hover flex h-full flex-col rounded-xl border border-black/10 bg-white p-6 shadow-sm hover:border-forest/40" to="/locations/san-antonio">
                    <h3 className="font-serif text-xl text-ink">San Antonio</h3>
                    <p className="mt-2 text-sm text-ink/70">Kitchen · Bath · ADU · Outdoor Living</p>
                  </Link>
                </div>
              </div>
                  <p className="reveal mt-8 text-center text-sm text-ink/70">Don't see your exact city? <Link className="font-semibold text-forest hover:text-forest-hover" to={ROUTES.SERVICE_AREAS}>Browse all service areas</Link> or <Link className="font-semibold text-forest hover:text-forest-hover" to={ROUTES.QUOTE}>request a quote</Link>.</p>
            </div>
          </section>

          <section id="quote" className="bg-forest-tint py-20 sm:py-28">
            <div className="container-page grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-start">
              <div className="quote-intro reveal">
                <div className="label-eyebrow">Get Your Free Quote</div>
                <h2 className="h-section mt-3 text-ink">Ready to talk about your project?</h2>
                <p className="mt-4 max-w-md text-ink/75">Tell us what you're planning and we'll help you take the next step.</p>
                <ul className="mt-6 space-y-2 text-ink/80">
                  <li>Free estimate.</li>
                  <li>No obligation.</li>
                  <li>No pressure.</li>
                </ul>
                <div className="mt-8 space-y-4 rounded-lg border border-black/5 bg-white p-6">
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-wider text-ink/60">Prefer to talk?</div>
                    <a href={`tel:${PHONE_TEL}`} className="mt-1 block font-serif text-3xl text-forest hover:text-forest-hover">{PHONE_DISPLAY}</a>
                  </div>
                  <div className="border-t border-black/5 pt-4 text-sm text-ink/75">
                    <div className="font-semibold text-ink">Hours</div>
                    <div>8am-9pm · 7 days a week</div>
                  </div>
                </div>
              </div>
              <div className="reveal"><QuoteForm /></div>
            </div>
          </section>
    </>
  );
}
